import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IonCard, IonCardContent, IonCol, IonIcon, IonRow } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import {
  EBillingStatus,
  EFastPaymentForCarrierStatus,
  EFreightForCarrierStatus,
  IFreightBasicForCarrier,
  IFreightDriver,
  IFreightVehicle,
} from '@okcargo-apps/shared-domain';
import { AppTab, ECapabilities } from '@okcargo-apps/shared-domain-ionic';
import { DateFnsModule } from 'ngx-date-fns';
import { AccountService } from '../../account';

@Component({
  selector: 'lib-freight-carrier-finished-card',
  templateUrl: './freight-carrier-finished-card.component.html',
  styleUrls: ['./freight-carrier-finished-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    IonIcon,
    IonCol,
    IonRow,
    IonCardContent,
    IonCard,
    DateFnsModule,
    TranslateModule,
  ],
})
export class FreightCarrierFinishedCardComponent {
  readonly freight = input.required<IFreightBasicForCarrier>();

  readonly hideColumns = input(false);

  private readonly accountService = inject(AccountService);

  public readonly EFreightStatus = EFreightForCarrierStatus;
  public readonly EInvoiceStatus = EBillingStatus;
  public readonly EFastPaymentForCarrierStatus = EFastPaymentForCarrierStatus;

  protected readonly canViewPrices = computed(() => this.accountService.hasCapability(ECapabilities.VIEW_PRICES));
  protected readonly canViewDrivers = computed(() => this.accountService.hasCapability(ECapabilities.VIEW_DRIVERS));

  protected AppTab = AppTab;

  protected readonly sizeLgStep = computed(() => (this.hideColumns() ? 6 : 4));

  protected readonly sizeLgReference = computed(() => (this.hideColumns() ? 12 : 2));

  public printDrivers(drivers: IFreightDriver[]): string {
    const driversArrayTxt: string[] = [];
    drivers.forEach((driver) => {
      if (driver.name !== undefined && driver.name !== '') {
        driversArrayTxt.push(driver.name);
      }
    });
    return driversArrayTxt.join(', ');
  }

  public printVehicles(vehicles: IFreightVehicle[]): string {
    const vehiclesArrayTxt: string[] = [];
    vehicles.forEach((vehicle) => {
      if (vehicle.plate !== undefined && vehicle.plate !== '') {
        vehiclesArrayTxt.push(vehicle.plate);
      }
    });
    return vehiclesArrayTxt.join(', ');
  }
}
